<script lang="ts" setup>
import type { BaseValidation } from "@vuelidate/core";

const emit = defineEmits<{
  (e: "update:countryId", value: string): void;
  (e: "update:stateId", value: string): void;
}>();

const props = withDefaults(
  defineProps<{
    countryId?: string;
    countryIdValidation?: BaseValidation;
  }>(),
  {
    countryId: "",
    countryIdValidation: undefined,
  },
);

const { countryId } = useVModels(props, emit);
const { getCountries } = useCountries();

</script>

<template>
  <div class="grid grid-cols-1 gap-4">
    <div class="relative">
      <select
        id="country"
        v-model="countryId"
        required
        name="country"
        autocomplete="country-name"
        class="appearance-none relative block w-full px-3 py-3 border placeholder-secondary-500 text-secondary-900 rounded-md focus:outline-none focus:ring-primary focus:z-10 sm:text-base border-secondary-300 focus:border-primary"
        :class="[
          countryIdValidation?.$error
            ? 'border-red focus:border-red border-1'
            : 'border-secondary-300',
        ]"
        data-testid="country-select"
        @blur="countryIdValidation?.$touch()"
      >
        <option value="" disabled>{{ $t("form.chooseCountry") }}</option>
        <option
          v-for="country in getCountries"
          :key="country.id"
          :value="country.id"
        >
          {{ country.name }}
        </option>
      </select>
      <span
        v-if="countryIdValidation?.$error"
        class="block mt-1 text-xs text-red"
      >
        {{ countryIdValidation.$errors[0].$message }}
      </span>
    </div>
  </div>
</template>
